import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, FileBlobService,} from '../../_services/index';
import {saveAs as importedSaveAs} from "file-saver";

@Component({
    standalone: false,
    selector: 'viewFile-component',
    templateUrl: 'viewFile.component.html'
})

export class ViewFileComponent {
  url: string;
  isImage: boolean;
  isPdf: boolean;
  blob: Blob;
  constructor(
    public dialogRef: MatDialogRef<ViewFileComponent>,
    public fileBlobService: FileBlobService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.url = data.url;
      this.isImage = !!['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp'].find(e => this.url.indexOf('.' + e) >= 0);
      this.isPdf = !!['pdf'].find(e => this.url.indexOf('.' + e) >= 0);
      if (this.isPdf) {
        this.fileBlobService.downloadFileByUrl(this.url).subscribe(
          (data) => {
            this.blob = new Blob([data]);
          }
        );
      }
  }


  onClose(): void {
      this.dialogRef.close();
  }
}
